<template>
    <div class="editor-row customize-editor-minimize">
        <div class="editor-row-title">{{ $t('auto.stringFormatterWordcountCountSpaces') }}</div>
        <a-switch v-model="clone.word_count.countSpaces" />
        <small class="description">
            {{ $t('auto.stringFormatterWordcountIncludeSpacesInTheWordCountCalculation') }}
        </small>
    </div>
</template>

<script>
import log2 from "../../../../../../../../utils/log2";
import _ from "lodash";

const log = log2("StringFormatterWordCount");
export default {
    name: "StringFormatterWordCount",
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "string.word_count",
            value: "",
            word_count: {
                countSpaces: false,
            },
        };
        return {
            clone,
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        value(newValue) {
            if (_.isEqual(newValue, this.clone)) return;
            this.clone = _.cloneDeep(newValue);
        },
    },
};
</script>

<style lang="scss" scoped>
.editor-row {
    width: 100%;

    &.customize-editor-minimize {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    small.description {
        font-size: 10px;
        color: var(--color-text-weak-default);
    }

    .editor-row-title {
        font-weight: bold;
        font-size: 16px;
    }
}
</style> 